/// <amd-module name="Feed/Legacy/Protocols/Components/PackageTile" />
import * as React from "react";

import { css } from "VSSUI/Util";

export interface IPackageTileProps {
    title?: string;
    id?: string;
    /* Optional css class from the component */
    cssClass?: string;
}

export class PackageTile extends React.PureComponent<IPackageTileProps> {
    public render(): JSX.Element {
        return (
            <div className={css("package-tile", this.props.cssClass)} id={this.props.id ? this.props.id : null}>
                {this.props.title && <h2 className="package-tile-title">{this.props.title}</h2>}
                <div className="package-tile-content">{this.props.children}</div>
            </div>
        );
    }
}
